import Product from './Product';
import Paginate from './Paginate';

const SearchResults = ({ productsData }) => {
    if (!productsData) {
        return <alert variant='info'>該当する商品はありません</alert>;
    }
    return (
        <>
            <ul className='product-list'>
                {productsData.products.map((product) => (
                    <Product
                        type="standard"
                        product={product}
                    />
                )) ?? []}
            </ul>
            {productsData.meta && productsData.meta.pages > 1 && (
                <Paginate
                    currentPage={productsData.meta.currentPage}
                    totalPages={productsData.meta.pages}
                />
            )}
        </>
    );
};

export default SearchResults;
